import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useActions } from '../hooks/useActions';
import { useLocalStorage } from '../hooks/useLocalStorage';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const [token] = useLocalStorage('accessToken', null);
  const { getConfig, getCompanies } = useActions();

  const setupAppData = () => {
    getConfig();
    getCompanies();
  };

  useEffect(() => {
    if (token) {
      setupAppData();
    }
  }, []);

  const location = useLocation();

  if (!token) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};
